export const QUERY_AGREEMENTS_KEY = 'agreements';
export const QUERY_AGREEMENT_KEY = 'agreement';
export const QUERY_PAYMENTS_KEY = 'payments';
export const QUERY_OFFERS_KEY = 'offers';
export const QUERY_CREDITOR_CONTACTS_KEY = 'creditorContacts';
